import { baseRequest } from '@thrivadev/thriva-request';
import { USER_MARK_FOR_DELETION_API_PATH } from './helpers';
const requestOptions = {
    method: 'POST'
};
/**
 * Marks the current user for deletion.
 *
 * @returns SuccessResponse
 */
export function markForDeletion() {
    return baseRequest(USER_MARK_FOR_DELETION_API_PATH, requestOptions);
}
//# sourceMappingURL=delete.js.map